import axios from 'axios'
import { URL } from '../../../../config'

export const postBakerBowlers = function (updates,token) 
{
  const bakerbowlersEndpoint = `/bakerbowlers/update`
  const  bakerbowlerURL =  `${URL.postevent}${bakerbowlersEndpoint}` 
  return axios.post(bakerbowlerURL,updates,
	{ 
    crossdomain: true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Authorization' : `Bearer ${token}` 
    }
  })  
}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/postBakerBowlers.js